import React, { useState } from 'react';
import css from './Sections.module.css';
const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={css.faqItem} onClick={() => setOpen(!open)}>
      <div className={css.faqHeader}>
        <span className={css.faqToggle}>{open ? '−' : '+'}</span>
        <p className={css.faqQuestion}>{question}</p>
      </div>
      {open && <p className={css.faqAnswer}>{answer}</p>}
    </div>
  );
};

const FAQSection = props => {
  const { intl } = props;
  const faqData = [
    {
      question: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.0.question' }),
      answer: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.0.answer' }),
    },
    {
      question: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.1.question' }),
      answer: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.1.answer' }),
    },
    {
      question: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.2.question' }),
      answer: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.2.answer' }),
    },
    {
      question: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.3.question' }),
      answer: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.3.answer' }),
    },
    {
      question: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.4.question' }),
      answer: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.4.answer' }),
    },
    {
      question: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.5.question' }),
      answer: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.5.answer' }),
    },
    {
      question: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.6.question' }),
      answer: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.6.answer' }),
    },
    {
      question: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.7.question' }),
      answer: intl.formatMessage({ id: 'ProgramOnboardingPage.faqs.7.answer' }),
    },
  ];

  return (
    <div>
      <section className={css.faqSection}>
        {/* <p className={css.faqLabel}>
          {intl.formatMessage({ id: 'ProgramOnboardingPage.faqLabel' })}
        </p> */}
        <h2 className={css.faqTitle}>
          {intl.formatMessage({ id: 'ProgramOnboardingPage.faqTitle' })}
        </h2>
        <div className={css.faqList}>
          {faqData.map((item, idx) => (
            <FAQItem key={idx} question={item.question} answer={item.answer} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default FAQSection;
